import React from "react";
import styled from "styled-components";
import { useIsMobile } from "@utils/hooks";

interface MasterProps extends React.HTMLAttributes<HTMLDivElement> {
	applicationId?: string;
}
const allprogramsLeft = [
	{
		programLabel: "Data  & IT",
		programs: [
			"Computer science",
			"Cyber Security",
			"Data Management",
			"Data Science",
			"Engineering Management",
			"Information Technology Management",
		],
	},
	{
		programLabel: "Marketing & Communication",
		programs: ["Marketing Management"],
	},
];
const allprogramsRight = [
	{
		programLabel: "Business & Management",
		programs: [
			"Business Intelligence",
			"Digital Innovation & Intrapreneurship",
			"Human Resource Management",
			"Innovation & Entrepreneurship",
			"International Management",
			"Management + Majors",
			"Project Management",
		],
	},
];
export const Master: React.FC<MasterProps> = ({ applicationId, ...htmlProps }) => {
	const isMobile = useIsMobile();
	return (
		<Container {...htmlProps}>
			{isMobile ? (
				<ContainerMobile>
					<>
						{allprogramsLeft.map((item) => {
							return (
								<>
									<ProramLabel>{item.programLabel}</ProramLabel>

									{item.programs.slice(0, 4).map((item) => {
										return <ProgramItem key={item}>{item}</ProgramItem>;
									})}
								</>
							);
						})}
						{/* {allprogramsRight.map((item) => {
							return (
								<>
									<ProramLabel>{item.programLabel}</ProramLabel>

									{item.programs.map((item) => {
										return <ProgramItem key={item}>{item}</ProgramItem>;
									})}
								</>
							);
						})} */}
					</>
				</ContainerMobile>
			) : (
				<>
					<Left>
						{allprogramsLeft.map((item) => {
							return (
								<>
									<ProramLabel>{item.programLabel}</ProramLabel>

									{item.programs.map((item) => {
										return <ProgramItem key={item}>{item}</ProgramItem>;
									})}
								</>
							);
						})}
					</Left>
					<Right>
						{allprogramsRight.map((item) => {
							return (
								<>
									<ProramLabel>{item.programLabel}</ProramLabel>

									{item.programs.map((item) => {
										return <ProgramItem key={item}>{item}</ProgramItem>;
									})}
								</>
							);
						})}
					</Right>
				</>
			)}
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: row;
`;
const ContainerMobile = styled.div`
	display: flex;
	flex-direction: column;
`;

const Left = styled.div`
	display: flex;
	flex-direction: column;
`;
const Right = styled.div`
	display: flex;
	flex-direction: column;
	margin-left: 120px;
`;
const ProramLabel = styled.div`
	margin-top: 20px;
	font-weight: 600;
	font-size: 16px;
	line-height: 20px;
	color: ${({ theme }) => theme.colors.vividBlue};
`;

const ProgramItem = styled.div`
	font-weight: 400;
	font-size: 13px;
	line-height: 18px;
	margin-top: 10px;

	color: #000000;
`;
